import { Component, OnInit } from '@angular/core';

import { BarcodeFormat } from '@zxing/library';
import { BarcodeCodeType, BarcodeType } from 'src/app/model/code.class';

@Component({
  selector: 'app-emed-barcode',
  templateUrl: './emed-barcode.component.html',
  styleUrls: ['./emed-barcode.component.scss']
})
export class EmedBarcodeComponent implements OnInit {
  /* Lista formati disponibili*/
  barcodeTypes: BarcodeCodeType[] = [];

  /* Lista formati selezionati */
  selectedBarcodeTypes: BarcodeCodeType[] = []

  /* Visualizzatore modal */
  formatsModal: boolean = false;

  /* Messaggio errore */
  requiredCode: boolean = false;

  /* Messaggio restituito dal barcode */
  barcodeMessage: string = '';

  camerasFounded: any[] = [];
  selectedCamera: any;

  ngOnInit(): void {
    this.selectedCamera = localStorage.getItem(localStorage.getItem("selectedCamera") || '{}');
    this.barcodeTypes = BarcodeType.allBarcodeTypes;

    if (localStorage.getItem("selectedBarcodeTypes") == null) {
      this.selectedBarcodeTypes = BarcodeType.defaultBarcodeTypes;

      return;
    }

    this.selectedBarcodeTypes = JSON.parse(localStorage.getItem("selectedBarcodeTypes") || '{}');
  }

  // !! Lista formati utilizzabili passati al componente
  public get allowedFormats(): BarcodeFormat[] {
    return BarcodeType.getBarcodeFormats(this.selectedBarcodeTypes);
  }

  // !! Apertura modale
  showDialog() {
    this.formatsModal = true;
  }

  // !! Salvataggio selezionati
  saveCodes() {
    if (this.selectedBarcodeTypes.length == 0) {
      this.requiredCode = true;
      return
    }

    localStorage.setItem('selectedCamera', JSON.stringify(this.selectedCamera));
    localStorage.setItem('selectedBarcodeTypes', JSON.stringify(this.selectedBarcodeTypes));

    this.requiredCode = false;

    this.formatsModal = false;
  }

  // !! Annullazione selezionati
  cancelCodes() {
    //TODO: Tenere traccia dei vecchi selezionati!
    this.formatsModal = false;
  }

  scanSuccessHandler(message: string) {
    this.barcodeMessage = message;
  }

  camerasFoundHandler(camera: any) {
    this.camerasFounded = camera;
    JSON.stringify(this.camerasFounded);
  }
}
